import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/seismic/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: true,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_DEPLOYMENTS_OVERRIDE: {
    '1.3.0': ['canonical', 'eip155'],
    '1.4.1': 'canonical',
  },
  SAFE_UTILS_SUPPORTED: false,
  EXTRA_FOOTER_LINKS: [
    { label: 'X', link: 'https://x.com/SeismicSys' },
    { label: 'Discord', link: 'https://discord.gg/XSPNseXCvW' },
  ],
  IS_LICENSED: false,
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '40px',
    },
    WELCOME: {
      W: '140px',
      H: '40px',
    },
  },
} as TemplateConfig
export default TEMPLATE_CONFIG
